/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function UpTo(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1023 16.5049C15.6064 16.5562 15.9998 16.9823 15.9998 17.5C15.9998 18.0177 15.6064 18.4438 15.1023 18.4951L14.9998 18.5H4.99976C4.44766 18.4998 3.99976 18.0521 3.99976 17.5C3.99976 16.9479 4.44766 16.5002 4.99976 16.5H14.9998L15.1023 16.5049ZM9.99976 5.66699C10.3197 5.66699 10.6202 5.82036 10.8083 6.0791L13.6423 9.97656L16.2195 8.68945C16.5774 8.51056 17.0079 8.5617 17.3132 8.82031C17.6186 9.07902 17.7395 9.49543 17.6218 9.87793L15.9558 15.2939C15.8266 15.7133 15.4386 16 14.9998 16H4.99976C4.53446 15.9998 4.13002 15.6789 4.02515 15.2256L2.77515 9.80859C2.68586 9.4217 2.83461 9.01832 3.15308 8.78125C3.47187 8.54428 3.90093 8.51882 4.24585 8.71582L6.38452 9.9375L9.19116 6.0791L9.26636 5.9873C9.45427 5.78451 9.71978 5.66711 9.99976 5.66699ZM7.47534 11.8389C7.17533 12.2508 6.61318 12.371 6.17065 12.1182L5.23804 11.585L5.79565 14H14.2615L15.0232 11.5225L13.78 12.1445C13.343 12.3627 12.8116 12.2339 12.5242 11.8389L9.99976 8.36621L7.47534 11.8389ZM2.49976 5C3.42023 5 4.16675 5.74652 4.16675 6.66699C4.16657 7.58732 3.42012 8.33301 2.49976 8.33301C1.57958 8.33278 0.833916 7.58718 0.83374 6.66699C0.83374 5.74666 1.57947 5.00022 2.49976 5ZM17.4998 5C18.4202 5 19.1667 5.74652 19.1667 6.66699C19.1666 7.58732 18.4201 8.33301 17.4998 8.33301C16.5796 8.33278 15.8339 7.58718 15.8337 6.66699C15.8337 5.74666 16.5795 5.00022 17.4998 5ZM9.99976 1.66699C10.9201 1.66699 11.6666 2.41268 11.6667 3.33301C11.6667 4.25348 10.9202 5 9.99976 5C9.07947 4.99978 8.33374 4.25334 8.33374 3.33301C8.33392 2.41282 9.07958 1.66722 9.99976 1.66699Z"
        fill="#35424F"
      />
    </svg>
  )
}

UpTo.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default UpTo
